import { render, staticRenderFns } from "./PriceFrontService.vue?vue&type=template&id=0ac54744&scoped=true&"
import script from "./PriceFrontService.vue?vue&type=script&lang=js&"
export * from "./PriceFrontService.vue?vue&type=script&lang=js&"
import style0 from "./PriceFrontService.vue?vue&type=style&index=0&id=0ac54744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac54744",
  null
  
)

export default component.exports